// extracted by mini-css-extract-plugin
module.exports = {"arrowDownIcon":"az_s6c"};